// Components==============
import Checkbox from 'components/UI/Checkbox';
import Dropdown from 'components/UI/Dropdown';
import SearchBar from 'components/UI/SearchBar';
import React, { useContext } from 'react';
import { MatchContext } from 'screens/Match';
import { StoreContext } from 'utilities/StoreContextWrapper';
import './index.module.scss';
// =========================

export default function Filter() {
    const {
        searchValue,
        setSearchValue,
        selectedSchools,
        setSelectedSchools,
        selectedEducationTypes,
        setSelectedEducationTypes,
    } = useContext(MatchContext);

    const educationTypes = [
        'fulltime',
        'structureel',
        'docentenfuncties',
        'tijdelijk',
        'parttime',
        'tijdelijk met uitzicht op vast',
        'onderwijsondersteunende functies',
        'overig',
    ];

    function handleClick(option) {
        const schoolExists = selectedEducationTypes.find(
            (current) => current === option
        );
        if (!schoolExists)
            return setSelectedEducationTypes((prev) => [...prev, option]);

        setSelectedEducationTypes((prev) =>
            prev.filter((current) => current !== option)
        );
    }

    const { schoolGroups } = useContext(StoreContext);

    return (
        <div styleName="wrapper">
            <div styleName="grid">
                <div styleName="item">
                    <SearchBar
                        searchValue={searchValue}
                        setSearchValue={setSearchValue}
                    />
                </div>
                <div styleName="item">
                    <Dropdown
                        text="Selecteer scholen"
                        options={schoolGroups.map((e) => e.name)}
                        selected={selectedSchools}
                        setSelected={setSelectedSchools}
                        absolute
                    />
                </div>
            </div>
            <div styleName="checkBoxes">
                {educationTypes.map((option) => {
                    const isSelected = selectedEducationTypes.find(
                        (e) => e === option
                    );

                    return (
                        <div
                            key={option}
                            onClick={() => handleClick(option)}
                            styleName="option"
                        >
                            <Checkbox
                                isSelected={isSelected}
                                background="#ffffff"
                            />
                            <p styleName={isSelected ? 'selected' : ''}>
                                {option}
                            </p>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
